export default {"src":"/kaimono/_next/static/media/fallbackImage.be12c2e4.svg","height":430,"width":430};